import { getDictPhrase } from "../../../common";
import { getSelectionDetailsProps } from "../../selection";
export const getSelectionDetailsListProps = (bet, state) => {
    return {
        betId: bet.betId,
        betExpandedProps: {
            expandedBetDetails: state.getBetExpandedProp(bet.betId, "expandedBetDetails")
        },
        setExpandedBetDetails: state.setExpandedBetDetails,
        selectionDetails: bet.selections.map(s => getSelectionDetailsProps(bet, s, state)),
        phraseViewMoreDetails: getDictPhrase(state.dict, "ViewBetDetails"),
        phraseViewLessDetails: getDictPhrase(state.dict, "HideBetDetails")
    };
};
//# sourceMappingURL=getSelectionDetailsListProps.js.map